import ChannelListChannelContainer from '../../atoms/container/channelListChannelContainer';
import ChannelListChannelTextContainer from '../../atoms/container/channelListChannelTextContainer';
import ChannelListChannelLogo from '../../atoms/images/channelListChannelLogo';
import ChannelListChannelDial from '../../atoms/text/channelListChannelDial';
import ChannelListChannelItemContainer from '../../atoms/container/channelListChannelItemContainer';
import ChannelListChannelText from '../../atoms/text/channelListChannelText';
import ListContext from '../../../../shared/components/utils/context/listContext';
import ManageChannelContext from '../../../../shared/components/utils/context/manageChannelsContext';
import Screen from '../../../../shared/utils/screen';
import { useContext, useEffect, useRef, useState } from 'react';

interface ChannelListChannelItem {
  available: boolean;
  index: number;
  dial: number;
  logo: string;
  title: string;
  releaseAction: () => void;
}

const checkOverflow = (textContainer: HTMLSpanElement | null): boolean => {
  if (textContainer)
    return (
      textContainer.offsetHeight < textContainer.scrollHeight ||
      textContainer.offsetWidth < textContainer.scrollWidth
    );
  return false;
};

function ChannelListChannelItem({
  available,
  dial,
  title,
  logo,
  index,
  releaseAction,
}: ChannelListChannelItem) {
  const { listIndex, setListIndex } = useContext(ListContext);
  const { editing, setEditing } = useContext(ManageChannelContext);
  const [hovered, setHovered] = useState(false);
  const [overflow, setOverflow] = useState<boolean>(false);

  const overflowingText = useRef<HTMLSpanElement | null>(null);

  const distanceToIndex = index - (listIndex || 0);
  const focused = listIndex === index;

  const borderStyle =
    focused && editing
      ? {
          border: 4 * Screen.widthRatio + 'px solid grey',
          borderRadius: 30 * Screen.widthRatio + 'px',
          paddingRight: 20 * Screen.widthRatio + 'px',
        }
      : {};
  const itemStyle = {
    opacity: focused || hovered ? 1 : 0.7,
  };
  const textSize = focused
    ? dial && dial < 100
      ? 42
      : dial < 1000
      ? 36
      : 30
    : 30;

  useEffect(() => {
    setTimeout(() => {
      setOverflow(checkOverflow(overflowingText.current));
    });
  }, [focused]);

  return (
    <>
      {distanceToIndex < 7 && (
        <ChannelListChannelItemContainer
          onClick={() => {
            focused ? releaseAction() : setListIndex(index);
            if (setEditing) setEditing(!editing);
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={itemStyle}
          id={'channelListChannelItemContainer'}
        >
          {distanceToIndex > -7 ? (
            <ChannelListChannelContainer
              style={borderStyle}
              id={'channelListChannelAnimatableContainer'}
            >
              <ChannelListChannelDial size={textSize}>
                {dial}
              </ChannelListChannelDial>
              <ChannelListChannelLogo src={logo}></ChannelListChannelLogo>
              <ChannelListChannelTextContainer>
                <ChannelListChannelText
                  available={available}
                  focused={focused}
                  ref={overflowingText}
                  scroll={overflow}
                >
                  {title}
                </ChannelListChannelText>
              </ChannelListChannelTextContainer>
            </ChannelListChannelContainer>
          ) : null}
        </ChannelListChannelItemContainer>
      )}
    </>
  );
}

export default ChannelListChannelItem;
